export const DASHBOARD = 'DASHBOARD';
export const GET_DASHBOARD_REQUEST = `${DASHBOARD}/getDashboardRequest`;
